import React, { useEffect, useState } from "react";
import JournalTimeline from "./JournalTimeline";
import JournalInfo from "./JournalInfo";
import { GET } from "../../../../../utils/fetchUtil";
import Tabs from "../../../../../common/tabs/Tabs";
import Tab from "../../../../../common/tabs/Tab";
import { useTranslation } from "react-i18next";

function Journal({ id, uid, subject, solver, statusText }) {
  const [activeTab, setActiveTab] = useState(0);
  const [doc, setDoc] = useState([]);
  const [work, setWork] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    GET(`/requests/${id}/submissions/${uid}/journal`, (journal) => {
      setDoc(journal.doc);
      setWork(journal.work);
    });
  }, [id, uid]);

  return (
    <div className="content">
      <div className="is-size-4">{statusText}</div>
      <div className="is-size-4">{subject}</div>
      <div className="is-size-4">{solver}</div>
      <Tabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabsClassName={"mt-6"}
        scrollToSection={false}
      >
        <Tab
          label={t("requests.overview.preview.journal.timeline.tab")}
          render={() => <JournalTimeline work={work} />}
        />
        <Tab
          label={t("requests.overview.preview.journal.info.tab")}
          render={() => <JournalInfo doc={doc} />}
        />
      </Tabs>
    </div>
  );
}

export default Journal;
